import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux"; // For user authentication state
import Navbar from "../Nav/Navbar";
import NotificationBell from "../NotificationBell/NotificationBell";
import "../Header/_header.scss";
import axios from "axios";

axios.defaults.baseURL = "https://book-lovers-4592.onrender.com" || "http://localhost:5003";

function Header() {
  const [stats, setStats] = useState({ books: 0, posts: 0, users: 0 });
  const location = useLocation(); // Hook to get the current path
  const isLoginPage = location.pathname === "/login";
  const user = useSelector((state) => state.auth.user); // Get the logged-in user

  const isHomePage = location.pathname === "/"; // Check if the current route is `/`
  const isNonUser = !user; // Check if the user is not logged in

  // Fetch stats for non-users on the homepage
  const fetchStats = async () => {
    try {
      const response = await axios.get("/stats"); // Fetch all counts in one request
      setStats(response.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  useEffect(() => {
    if (isHomePage || isLoginPage) {
      fetchStats(); // Fetch stats only on the homepage for non-users
    }
  }, [isHomePage, isLoginPage]);

  return (
    <header className="header" role="banner">
      <div className="header-content">
      <div className="logo-container">
       <Link to="/" className="logo" aria-label="Homepage">
          <img loading="lazy" src="/logo.webp" alt="Website Logo" />
        </Link>
        </div>
        <div className="navbar-container"></div>
        <Navbar />
        {user && <NotificationBell mode="header" />} 
        {(isHomePage || isLoginPage) && !user && (
  <div className="header-stats">
    <div className="stat">
      <h1>{stats.books.toLocaleString()}</h1>
      <p>Books</p>
    </div>
    <div className="stat">
      <h1>{stats.posts.toLocaleString()}</h1>
      <p>Publications</p>
    </div>
    <div className="stat">
      <h1>{stats.users.toLocaleString()}</h1>
      <p>Membres</p>
    </div>
  </div>
)}

      </div>
    </header>
  );
}

export default Header;
